import React, { useCallback } from 'react';
import { Editor } from '@tinymce/tinymce-react';

/** Pin to the installed `tinymce` package version for CDN script + assets. */
const TINYMCE_VER = '8.4.0';
const CDN_BASE = `https://cdn.jsdelivr.net/npm/tinymce@${TINYMCE_VER}`;

type Props = {
  id: string;
  name: string;
  value: string | null | undefined;
  disabled?: boolean;
  readonly?: boolean;
  height?: number;
  placeholder?: string;
  onChange: (name: string, value: string) => void;
};

export const OrgStatementTinyMceField: React.FC<Props> = ({
  id,
  name,
  value,
  disabled,
  readonly,
  height = 280,
  placeholder,
  onChange,
}) => {
  const handleEditorChange = useCallback(
    (content: string) => {
      onChange(name, content);
    },
    [name, onChange]
  );

  return (
    <div className="org-statement-tinymce mb-1">
      <Editor
        id={id}
        tinymceScriptSrc={`${CDN_BASE}/tinymce.min.js`}
        value={value ?? ''}
        disabled={Boolean(disabled || readonly)}
        onEditorChange={handleEditorChange}
        init={{
          height,
          placeholder,
          menubar: false,
          branding: false,
          promotion: false,
          license_key: 'gpl',
          base_url: CDN_BASE,
          suffix: '.min',
          plugins: 'lists link autolink code wordcount',
          toolbar:
            'undo redo | blocks | bold italic underline strikethrough | alignleft aligncenter alignright | bullist numlist | link removeformat | code',
          content_style:
            'body { font-family: system-ui, -apple-system, Segoe UI, sans-serif; font-size: 14px; background-color: #f8f9fa; }',
        }}
      />
    </div>
  );
};
